import {
  Document,
  Image,
  Page,
  PDFViewer,
  Text,
  View,
} from '@react-pdf/renderer';
import QRCode from 'qrcode';
import { useHistory } from 'react-router-dom';
import { usePDFAssistanceData } from '../../hooks/usePDFAssistanceData';
import { Button } from '..';
import logo from '../../assets/logo.png';
import check from '../../assets/icons/check.png';
import uncheck from '../../assets/icons/not-check.png';
import brokenFile from '../../assets/broken-file.svg';

import pdfStyles from './pdf-styles';
import * as S from './styles';

const AssistancePDF = () => {
  const history = useHistory();
  const { pdfAssistanceData } = usePDFAssistanceData();
  const canvas = document.createElement('canvas');
  let osNumber = pdfAssistanceData?.os_control
    ? pdfAssistanceData?.os_control
    : undefined;
  let registerByName = pdfAssistanceData?.register_by_name
    ? pdfAssistanceData?.register_by_name
    : undefined;

  if (osNumber === undefined) {
    osNumber = '-1';
  }

  if (registerByName === undefined) {
    registerByName = 'indefinido';
  }

  QRCode.toCanvas(
    canvas,
    `${process.env.REACT_APP_API_URL}/pre-os/${osNumber}?register_by=${registerByName}`,
  );
  const qrcde = canvas.toDataURL();

  if (!pdfAssistanceData?.customer) {
    return (
      <S.ContainerError>
        <img src={brokenFile} alt="Imagem de um papel rasgado ao meio" />
        <strong>Ooops...</strong>
        <p>
          Não foi possível visualizar seu PDF agora. Tente voltar e gerar
          novamente. Se o problema persistir, contate o administrador.
        </p>
        <Button
          text="Voltar"
          outlined
          containerStyle={{ alignSelf: 'center', marginTop: '0.8rem' }}
          onClick={() => history.goBack()}
        />
      </S.ContainerError>
    );
  }

  return (
    <S.Container>
      <div style={{ height: '100%' }}>
        <Button
          text="Voltar"
          outlined
          containerStyle={{
            position: 'absolute',
            top: 20,
            left: 10,
            zIndex: 1000,
            borderColor: '#fff',
            color: '#fff',
          }}
          onClick={() => history.goBack()}
        />
      </div>
      <div>
        <PDFViewer style={pdfStyles.viewer}>
          <Document>
            <Page size="A4" wrap style={pdfStyles.page}>
              <View style={pdfStyles.header}>
                <Image src={logo} style={pdfStyles.logo} />

                <View style={pdfStyles.osInfoHeader}>
                  <View style={pdfStyles.osInfoContainer}>
                    <Text style={pdfStyles.osInfoLabel}>Número da O.S.:</Text>
                    <Text>{osNumber}</Text>
                  </View>
                  <View style={pdfStyles.osInfoContainer}>
                    <Text style={pdfStyles.osInfoLabel}>Aberto em:</Text>
                    <Text>
                      {new Date(pdfAssistanceData.open).toLocaleString('pt-BR')}
                    </Text>
                  </View>
                </View>

                <Image src={qrcde} style={pdfStyles.qrcode} />
              </View>

              <View style={pdfStyles.clientInfo}>
                <View style={pdfStyles.osInfoContainer}>
                  <Text style={pdfStyles.osInfoLabel}>Cliente:</Text>
                  <Text>{pdfAssistanceData.customer}</Text>
                </View>
                <View style={pdfStyles.osInfoContainer}>
                  <Text style={pdfStyles.osInfoLabel}>Assistência Técnica</Text>
                </View>
              </View>

              {/* Dados do atendimento */}
              <Text style={pdfStyles.sectionTitle}>Dados do atendimento</Text>
              <View style={pdfStyles.section}>
                <View />
                <View style={pdfStyles.osInfoSection}>
                  <Text style={pdfStyles.osInfoServiceLabel}>Adaptação:</Text>
                  <Image
                    src={
                      Number(pdfAssistanceData.is_adaptation) === 1
                        ? check
                        : uncheck
                    }
                    style={pdfStyles.icon}
                  />
                </View>

                <View style={pdfStyles.osInfoSection}>
                  <Text style={pdfStyles.osInfoServiceLabel}>Conserto:</Text>
                  <Image
                    src={
                      Number(pdfAssistanceData.is_repair) === 1
                        ? check
                        : uncheck
                    }
                    style={pdfStyles.icon}
                  />
                </View>

                <View style={pdfStyles.osInfoSection}>
                  <Text style={pdfStyles.osInfoServiceLabel}>Assistência:</Text>
                  <Image
                    src={
                      Number(pdfAssistanceData.is_assistance) === 1
                        ? check
                        : uncheck
                    }
                    style={pdfStyles.icon}
                  />
                  <Text />
                  <Text style={pdfStyles.assitanceInfoLabel}>
                    {pdfAssistanceData.assistance_type}
                  </Text>
                </View>
              </View>

              {/* Solicitação */}
              <Text style={pdfStyles.sectionTitle}>Solicitação</Text>
              <View style={pdfStyles.section}>
                <Text>{pdfAssistanceData.request}</Text>
              </View>

              {/* Analise tecnica */}
              <Text style={pdfStyles.sectionTitle}>Análise Técnica</Text>
              <View style={pdfStyles.section}>
                <Text>
                  {pdfAssistanceData.technical_analysis
                    ? pdfAssistanceData.technical_analysis
                    : 'Nenhum'}
                </Text>
              </View>

              {/* Procedimentos */}
              <Text style={pdfStyles.sectionTitle}>Procedimentos</Text>
              <View style={pdfStyles.section}>
                <Text>
                  {pdfAssistanceData.procedures
                    ? pdfAssistanceData.procedures
                    : 'Nenhum'}
                </Text>
              </View>

              {/* Decisao */}
              <Text style={pdfStyles.sectionTitle}>Decisão</Text>
              <View style={pdfStyles.section}>
                <Text>{pdfAssistanceData.accept ? 'A C E I T E' : ''}</Text>
                <Text>
                  {pdfAssistanceData.cancel ? 'I N D E F E R I D O' : ''}
                </Text>
                <Text>
                  {!pdfAssistanceData.cancel && !pdfAssistanceData.accept
                    ? 'AGUARDANDO DECISÃO'
                    : ''}
                </Text>
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </div>
    </S.Container>
  );
};

export default AssistancePDF;
